import { closeLoading, openError } from 'gf-ui'
import React from 'react'
import { Button } from 'react-bootstrap'
import { FaPrint } from 'react-icons/fa'
import { useDispatch } from 'react-redux'

const BtnStampa = ({ apiClient, numeroScheda, modello }) => {

  const dispatch = useDispatch()  

  const stampa = () => {
    apiClient.fnStampa(
        (status) => { 
            // Qui il file è già stato scaricato da _fetchDownload
            closeLoading(dispatch);
        }, 
        null, // params
        `${modello} - Questionario n. ${numeroScheda.replace("/", " del ")}.pdf`, 
        (status, err) => openError(dispatch, err || "Errore")
    );    
  }

  return (
    <Button variant="info" size="lg" onClick={stampa} className='text-primary' ><FaPrint /> Stampa</Button>
  )
}

export default BtnStampa